import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { TokenCache } from '../../security/token-cache';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-reports-home',
  templateUrl: './reports-home.component.html',
  styleUrls: ['./reports-home.component.css']
})
export class ReportsHomeComponent implements OnInit, OnDestroy {
  selectedIndex: number;
  mode: string;
  showSystemSummary: boolean;
  private routerSubscription: Subscription;

  constructor(
    private tokenCache: TokenCache,
    private router: Router
  ) { }

  ngOnInit() {
    this.showSystemSummary = !this.tokenCache.checkForLAZUser();
    this.syncFromUrl(this.router.url);
    this.routerSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.syncFromUrl(event.urlAfterRedirects);
      });
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  private getTabs(): string[] {
    const tabs = [
      'reserved-meter',
      'reserved-space',
      'temp-removals',
      'workorders',
      'meter-downtime'
    ];

    if (this.showSystemSummary) {
      tabs.push('system-summary');
    }

    tabs.push('change-audit');
    tabs.push('collections');
    return tabs;
  }

  public onTabChange(tabChangeEvent: MatTabChangeEvent): void {
    this.navigateToTab(tabChangeEvent.index);
  }

  private navigateToTab(index: number): void {
    const tabKey = this.getTabs()[index];
    if (!tabKey) {
      return;
    }

    const targetUrl = `/reports/${tabKey}`;
    if (this.router.url !== targetUrl) {
      this.router.navigateByUrl(targetUrl);
    }
  }

  private syncFromUrl(url: string): void {
    const tabs = this.getTabs();
    const resolvedKey = tabs.find((tab) => url.includes(`/reports/${tab}`));
    const index = resolvedKey ? tabs.indexOf(resolvedKey) : 0;
    const normalizedKey = tabs[index];
    this.selectedIndex = index;

    const targetUrl = `/reports/${normalizedKey}`;
    if (!url.includes('/reports/') || !url.includes(targetUrl)) {
      this.router.navigateByUrl(targetUrl, { replaceUrl: true });
    }
  }

}
